import { TypographyH3, TypographyP } from '@talentmesh/ui/components/typography';
import UIStrings from '@/Utils/UIStrings';

interface ScoreDetailsHeaderProps {
    description: string;
}

function ScoreDetailsHeader({ description }: ScoreDetailsHeaderProps) {
    return (
        <div className="flex flex-col items-center justify-center gap-4">
            <TypographyH3 className="text-foreground text-2xl leading-none">{UIStrings.ScoreDetails}</TypographyH3>
            <TypographyP className="text-foreground text-center">{description}</TypographyP>
        </div>
    );
}

export default ScoreDetailsHeader;
